<template>
  <view-page
    :title="pageTitle"
    permission-name="asset_reservation_object"
    :edit-button="false"
    :delete-button="false"
    :loading="loading"
  >
    <template v-slot:leftSide>
      <view-page-data-field
        v-if="fields.length > 0"
        v-for="field in fields"
        :key="field.label"
        :icon="field.icon"
        :label="field.label"
        :data="field.data"
      />
    </template>
  </view-page>
</template>

<script>
import ViewPage from "@/components/Management/ViewPage/ViewPage";
import ViewPageDataField from "@/components/Management/ViewPage/ViewPageDataField";
import TaskChecklistTable from "@/components/Home/Forms/_SpecialTabs/Activities/TaskTypes/Checklists/ChecklistTable";
import { mapActions } from "vuex";

export default {
  name: "AssetReservationManagementAssetDetails",

  components: { TaskChecklistTable, ViewPageDataField, ViewPage },

  data() {
    return {
      /**
       * Stores asset reservation data
       */
      assetReservationObject: null,
      /**
       * Define if the page is loading
       */
      loading: true,

      /**
       * Determines the fields to be displayed on the left side of the page
       */
      fields: null
    };
  },

  computed: {
    /**
     * Determines the value of layer attribute
     * @returns {string}
     */
    layerName() {
      if (this.assetReservationObject) {
        let layerTranslationName = this.$store.getters.getLayerTranslationKey(
          this.assetReservationObject.aro_object_layer
        );
        return this.$i18n.tc(layerTranslationName, 1);
      }
    },

    /**
     * Determines the title of the page
     * @returns {string}
     */
    pageTitle() {
      let title = "";
      if (this.assetReservationObject) {
        if (this.assetReservationObject.object_label) {
          title = this.assetReservationObject.object_label;
        } else {
          title = this.layerName + " " + this.assetReservationObject.object_id;
        }
      }
      return title;
    }
  },

  mounted() {
    this.getAssetReservationObject();
  },

  methods: {
    ...mapActions(["fetchAssociatedObjectByUuid"]),

    /**
     * Get asset reservation by the uuid and object uuid that is defined in the current page route
     * @return {Promise<void>}
     */
    async getAssetReservationObject() {
      try {
        this.assetReservationObject = await this.fetchAssociatedObjectByUuid({
          assetReservationUuid: this.$route.params.uuid,
          objectUUID: this.$route.params.objectUuid,
          fieldsToAppend: "state"
        });
        this.fields = this.getFields();
      } catch (error) {
        console.error(error);
        await this.$router.replace("/error");
      } finally {
        this.loading = false;
      }
    },

    /**
     * Define the values of the fields variable
     * {String} icon - Field icon
     * {String} label - Field label
     * {String} data - Field value
     * {Boolean} hasPermission - Determines if the user has permission to see the field.
     */
    getFields() {
      return [
        {
          icon: "assignment_turned_in",
          label: this.$i18n.t("State"),
          data: this.getAssetReservationState(this.assetReservationObject.state)
        },
        {
          icon: "layers",
          label: this.$i18n.tc("Layer", 1),
          data: this.layerName
        },
        {
          icon: "fingerprint",
          label: "ID",
          data: this.assetReservationObject.object_id
        },
        {
          icon: "label",
          label: this.$i18n.tc("Label", 1),
          data: this.assetReservationObject.object_label
        },
        {
          icon: "mdi-calendar-plus",
          label: this.$i18n.t("CreationDate"),
          data: this.assetReservationObject.aro_created_at
        },
        {
          icon: "event",
          label: this.$i18n.t("InstallationStartDate"),
          data: this.assetReservationObject.aro_installation_start_date
        },
        {
          icon: "event",
          label: this.$i18n.t("InstallationEndDate"),
          data: this.assetReservationObject.aro_installation_end_date
        },
        {
          icon: "event",
          label: this.$i18n.t("DroppedDate"),
          data: this.assetReservationObject.aro_dropped_date
        },
        {
          icon: "notes",
          label: this.$i18n.tc("Comment", 2),
          data: this.assetReservationObject.aro_comment
        }
      ];
    },

    /**
     * Returns the state of the selected asset reservation
     * @param state
     * @returns {*}
     */
    getAssetReservationState(state) {
      let stateDescription = state.main_description;
      stateDescription += state.secondary_description
        ? ", " + state.secondary_description
        : "";

      return stateDescription;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AssetReservationManagement/Data/AssetDetails.vue